import styled from 'styled-components';
import LogoConlicitacaoWhite from 'assets/images/logo-conlicitacao-white.png';

export const Container = styled.div`
  @import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');
  font-family: 'Poppins', sans-serif !important;
  margin-top: 20px;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;

  .page-container {
    max-width: 1050px;
    width: 100%;
    padding: 20px;
  }

  .div_logo {
    background-color: #14c585;
    background-image: url(${LogoConlicitacaoWhite});
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 7px;
    max-width: 200px;
    min-height: 40px;
    z-index: 1;
  }
  .div_logo_sider {
    position: relative;
    margin-left: -50px;
  }
  .div_logo_interna {
    border: 2px solid #adadad;
    border-radius: 7px;
    padding: 4px 0 0 40px;
    margin: 4px 0;
    font-weight: 800 !important;
    font-size: 20px;
  }
  .font_14 {
    font-size: 14px;
    font-weight: 500;
  }
  .font_16 {
    font-size: 16px;
    font-weight: 500;
  }
  .font_17 {
    font-size: 17px;
    font-weight: 500;
  }
  .font_18 {
    font-size: 18px;
    font-weight: 800;
    margin-bottom: 13px;
  }
  .font_25 {
    font-size: 25px;
    font-weight: 700;
    border-radius: 25px;
    color: #ffffff;
    background-color: #14c585;
  }
  .font_30 {
    font-size: 30px;
    font-weight: 800;
    margin-bottom: 13px;
    padding-left: 7rem !important;
  }
  .beneficios {
    border: 1.5px solid #14c585;
    border-radius: 7px;
    margin-bottom: 10px;
    padding: 6px 16px;
  }
  header,
  section {
    max-width: 1200px;
  }
  .hr_renewal {
    margin-top: 40px;
    margin-bottom: 40px;
    background-color: #adadad;
    border: 1px solid #adadad;
  }
  .info_servicos {
    border: 2px solid #14c585;
    border-radius: 29px;
    font-size: 13px;
    font-weight: 400;
    padding: 20px;
    margin: 15px 15px 0 0;
  }
  .center-image {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
